const SCROLL_THRESHOLD = 2;
const attached = new WeakSet();

function syncScrollClass(el) {
  const scrolled = el.scrollLeft > SCROLL_THRESHOLD;
  el.classList.toggle("is-scrolled", scrolled);
}

/** Match col-2 `left` to measured col-1 width so sticky columns never overlap. */
function syncStickyColumnOffset(el) {
  const table = el.querySelector("table");
  if (!table) return;

  const firstHeader = table.querySelector("thead th:first-child");
  if (!firstHeader) return;

  const width = Math.ceil(firstHeader.getBoundingClientRect().width);
  if (width > 0) {
    el.style.setProperty("--coa-sticky-col2-left", `${width}px`);
  }
}

function syncCoaTableScroll(el) {
  syncStickyColumnOffset(el);
  if (el.scrollWidth <= el.clientWidth + SCROLL_THRESHOLD) {
    el.classList.remove("is-scrolled");
  } else {
    syncScrollClass(el);
  }
}

function attachCoaTableScrollShadow(el) {
  if (!el?.classList?.contains("coa-table-scroll") || attached.has(el)) {
    return;
  }
  attached.add(el);

  const onScroll = () => syncCoaTableScroll(el);
  el.addEventListener("scroll", onScroll, { passive: true });

  const resizeObserver =
    typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(() => syncCoaTableScroll(el))
      : null;

  if (resizeObserver) {
    resizeObserver.observe(el);
    if (el.firstElementChild) {
      resizeObserver.observe(el.firstElementChild);
    }
  }

  requestAnimationFrame(() => syncCoaTableScroll(el));
}

export function initCoaTableScrollShadow(root = document) {
  const scope = root?.body ?? root;
  if (!scope?.querySelectorAll) {
    return () => {};
  }

  scope.querySelectorAll(".coa-table-scroll").forEach(attachCoaTableScrollShadow);

  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.classList?.contains("coa-table-scroll")) {
          attachCoaTableScrollShadow(node);
        }
        node.querySelectorAll?.(".coa-table-scroll").forEach(attachCoaTableScrollShadow);
      });
    }
  });

  mutationObserver.observe(scope, { childList: true, subtree: true });

  return () => mutationObserver.disconnect();
}
